import { iframeResizer } from 'iframe-resizer';

/*
 * Resize the Catalogue iframes
 */
export default function initCatalogue() {
    const catalogueFrame = document.getElementById('wcml-catalogue');
    let isFirstLoad = true;

    if (catalogueFrame) {
        iFrameResize({}, '#wcml-catalogue');

        catalogueFrame.onload = function () {
            if (isFirstLoad) {
                isFirstLoad = false;
                return; // Don't scroll on first load
            }

            catalogueFrame.scrollIntoView({ behavior: "instant", block: "start" });
        }
    }
};
